export enum Categories {
  accessories = 'accessories',
  phones = 'phones',
  tablets = 'tablets',
}
